<template>
  <div>
    <!-- <custom-select
      :selected="send_to"
      :arr="arr"
      :placeholder="placeholder"
      @on_search="on_search"
      @on_select="select_data"
      @on_arrow_up="on_arrow_up"
      @on_arrow_down="on_arrow_down"/> -->
    <v-select :options="arr"
      v-model="data"
      @search="on_search"/>
  </div>
</template>

<script>
import custom_select from '@/layout/custom_select'
import vSelect from 'vue-select'

import 'vue-select/dist/vue-select.css'

export default {
  props: ['search_url','placeholder','index_type'],
  components:{
    'custom-select': custom_select,
    'v-select': vSelect,
  },
  watch:{
    index_type(val){
      this.send_to = ''
      this.selected = {}
      this.$emit('on_selected',this.selected)
    },
  },
  data(){
    return{
      index: null,
      send_to: '',
      selected: {},
      arr: [],
      is_list_show: false,
      data: {},
      timeout: null,
    }
  },
  watch: {
    data(val){
      this.select_data_new()
    }
  },
  methods:{
    select_data_new(){
      this.$emit('on_selected',this.data)
    },
    select_data(index){
      this.send_to = this.arr[index].name
      this.selected = this.arr[index]
      this.index = index
      this.$emit('on_selected',this.selected)
    },
    on_search(search , loading){
      if(this.timeout != null)
        clearTimeout(this.timeout)
      var context = this
      this.timeout = setTimeout(() => {
        context.send_to = search 
        context.search_data()
      }, 1000)
    },
    on_arrow_up(){
      this.index--
      if(this.index < 0)
        this.index = this.arr.length - 1

      this.select_data(this.index)
    },
    on_arrow_down(){
      this.index++
      if(this.index > this.arr.length - 1)
        this.index = 0

      this.select_data(this.index)
    },
    async search_data(){
      try{
        var response = await axios.get(this.search_url+'?search='+this.send_to)

        var response_data = response.data
        if(response_data.status == "success"){
          response_data.data.forEach((data) => {
            data.label = data.name
          })
          this.arr = response_data.data
          this.is_list_show = true
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e.message)
      }
    },
  }
}
</script>
